import React, {Component} from 'react';
import {
    Card,
    CardBody,
    CardImage,
    CardTitle,
    CardText,
    Container,
    Col,
    View, Mask, Row, Fa
} from "mdbreact";
import {Link} from "react-router-dom";
import "./../../assets/images/help/hub_bigHeader.png";


export default class HowItWorks extends Component {
    render() {
        return (
            <div >
                <div className="jumbotron text-center rtl" style={{background:"#000 url(./../../assets/images/help/hub_bigHeader.png) no-repeat center bottom"}}>

                    <div className="container d-flex justify-content-start align-self-stretch  mt-5">
                        <div className="p-2 text-right rtl">
                            <h1 className="pag-title text-white">مرکز آموزش</h1>
                        </div>
                        <div className="ml-auto p-2">

                        </div>
                    </div>
                </div>
                <Container className="mt-5 mb-5 rtl">
                   <Row>
                       <Col md="12" sm="12">
                           <div className="w-100 border border-info p-3">

                               <View zoom className='w-100'>
                                   <img src="./../../assets/images/help/faqs.jpg" className="img-fluid" alt="" />
                                   <Mask className="flex-center"/>

                               </View>

                           </div>

                       </Col>
                      {/* <Col md="3" sm="12">
                           <div className="w-100 border border-info p-3">
                               <h4 className="text-center">محبوبترین ها</h4>





                           </div>
                       </Col>*/}
                   </Row>


                </Container>
                <Container className="rtl" >
                    <Row className="">
                        <Col md="4" sm="2" className="mb-5">
                            <Card>
                                <CardImage className="img-fluid" src="./../../assets/images/help/default_img.jpg" />
                                <CardBody>
                                    <CardTitle>
                                        <Link to='/faq/1'>عنوان آموزش</Link>
                                    </CardTitle>
                                    <CardText className="text-justify">
                                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
                                    </CardText>
                                    <hr/>
                                    <div className="d-flex justify-content-between">

                                        <div className="grey-text p-2">
                                            <Fa icon="calendar"/>
                                            <span>22 May, 2016</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="film" className="amber-text"/>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="thumbs-o-up "  className="blue-text"/>
                                            <span>239</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="eye" className="blue-text"/>
                                            <span>11792</span>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md="4" sm="2" className="mb-5">
                            <Card>
                                <CardImage className="img-fluid" src="./../../assets/images/help/Ping_Offers.jpg" />
                                <CardBody>
                                    <CardTitle>
                                        <Link to='/faq/2'>عنوان آموزش</Link>
                                    </CardTitle>
                                    <CardText className="text-justify">
                                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
                                    </CardText>
                                    <hr/>
                                    <div className="d-flex justify-content-between">

                                        <div className="grey-text p-2">
                                            <Fa icon="calendar"/>
                                            <span>22 May, 2016</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="film" className="amber-text"/>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="thumbs-o-up "  className="blue-text"/>
                                            <span>239</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="eye" className="blue-text"/>
                                            <span>11792</span>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md="4" sm="2" className="mb-5">
                            <Card>
                                <CardImage className="img-fluid" src="./../../assets/images/help/Hotels_Worldwide.jpg" />
                                <CardBody>
                                    <CardTitle>
                                        <Link to='/faq/3'>عنوان آموزش</Link>
                                    </CardTitle>
                                    <CardText className="text-justify">
                                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
                                    </CardText>
                                    <hr/>
                                    <div className="d-flex justify-content-between">

                                        <div className="grey-text p-2">
                                            <Fa icon="calendar"/>
                                            <span>22 May, 2016</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="film" className="amber-text"/>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="thumbs-o-up "  className="blue-text"/>
                                            <span>239</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="eye" className="blue-text"/>
                                            <span>11792</span>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md="4" sm="2" className="mb-5">
                            <Card>
                                <CardImage className="img-fluid" src="./../../assets/images/help/Mark_as_favourite_and_share_offers.jpg" />
                                <CardBody>
                                    <CardTitle>
                                        <Link to='/faq/4'>عنوان آموزش</Link>
                                    </CardTitle>
                                    <CardText className="text-justify">
                                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
                                    </CardText>
                                    <hr/>
                                    <div className="d-flex justify-content-between">

                                        <div className="grey-text p-2">
                                            <Fa icon="calendar"/>
                                            <span>22 May, 2016</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="film" className="amber-text"/>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="thumbs-o-up "  className="blue-text"/>
                                            <span>239</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="eye" className="blue-text"/>
                                            <span>11792</span>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>

                    </Row>
                </Container>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/faq/faq.js